import store from '@/Store'

const urlBase = process.env.VUE_APP_OMNI_API_MEETING_URL
const OmniMeetingnApi = (API) => {
  return {
    async permissoes () {
      const url = `${urlBase}/contato/permissoes`
      return API.get(
        url,
        {
          headers: {
            instancia_aplicacao: store.getters['SetupApp/instanciaAplicacao'],
            bundle: store.getters['SetupApp/bundle']
          }
        }
      )
    },
    async alterarResponsavel ({ idMeeting, chaveUnica, nome, dadosContato }) {
      const url = `${urlBase}/meetings/alterarResponsavel`
      return API.post(
        url,
        { idMeeting, chaveUnica, nome, dadosContato },
        {
          headers: {
            instancia_aplicacao: store.getters['SetupApp/instanciaAplicacao'],
            bundle: store.getters['SetupApp/bundle']
          }
        }
      )
    }
  }
}

export default OmniMeetingnApi
